import styled from "@emotion/styled"
import { Autocomplete, CheckboxCustom, Grid, Input, spacing, theme, Theme, Typography } from "@yuno/design-system-web"
type StyledProps = { theme?: Theme }

export const Category = styled.div<{ theme?: Theme }>`
display: flex;
justify-content: space-between;
align-items: center;
align-self: start;
color: ${({ theme }) => theme.palette.grey[5]};
font-size: ${({ theme }) => theme.typography.tiny.regular.fontSize};
font-family: ${({ theme }) => theme.typography.tiny.regular.fontFamily};
padding-top: 5px;
padding-bottom: 5px;
padding-left: 6px;
padding-right: 6px;
border: 1px solid ${({ theme }) => theme.palette.grey[2]};
border-radius: 4px;
`

export const TextDivisor = styled(Typography) <{ theme?: Theme }>`
color: ${({ theme }) => theme.palette.neutral.black};
font-size: ${({ theme }) => theme.typography.small.regular.fontSize};
padding-bottom: 4px;
border-bottom: 2px solid ${({ theme }) => theme.palette.vivid.brand};
width: 76px;
margin-bottom: 40px;
`


export const ContentStyled = styled('div')(({theme}: {theme?: Theme}) => ({
    '& .MuiTypography-root': {
        ...theme.typography.small.regular,
        color: theme.palette.neutral.black,
        marginBottom: '20px'
    }
}))

export const CheckboxStyled = styled(CheckboxCustom)(({theme}: {theme?: Theme}) => ({
    padding: "1px",
    width: '18px'
}))
export const RowStyled = styled('div')(({theme}: {theme?: Theme}) => ({
    width: '100%',
    marginBottom: '4px'
}))

export const SubTitle = styled(Typography)<StyledProps>`
  color: ${({ theme }) => theme.palette.grey[5]};
  font-size: ${({ theme }) => theme.typography.tiny.regular.fontSize};
  overflow: hidden;
  height: 36px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

export const TypographyStyled = styled(Typography)`
margin-left: 9px;
`

export const GridContainerField = styled(Grid)(() => ({
    paddingTop: '20px',
    '& .input-adornment': {
      '& .MuiInputBase-root': {
        padding: '0',
        '& input': {
          paddingLeft: '24px',
          fontSize: '14px'
        },
      },
    },
    '& .MuiFormControl-root': {
      width: '100% !important'
    }
  }))

  export const InputLabelStyled = styled.div<{ theme?: Theme }>`
  font-size: ${({ theme }) => theme.typography.tiny.regular.fontSize};
  margin-bottom: ${spacing.m};
`

export const AutocompleteStyled = styled(Autocomplete)(
    ({ theme }: { theme?: Theme }) => ({
      '& .MuiTextField-root': {
        width: '100%',
      },
      '& .MuiTextField-root .MuiInputBase-root': {
        width: 'auto',
      },
    }),
  )

  export const InputStyled = styled(Input)(
    ({ theme }: { theme?: Theme }) => ({
      fontSize: '14px'
    }),
  )
export const LinkA = styled('a')`
    text-decoration: none;
`

export const SpanOptional = styled('span')(
  ({ theme }: { theme?: Theme }) => ({
   color: theme.palette.grey[4],
   fontSize: theme.typography.tiny.regular.fontSize
  }),
)